<template>
	<Disclosure as="nav" class="bg-mabey-950 mt-[-1px]" data-testid="driver-bar">
		<div class="mx-auto px-4">
			<div class="relative flex py-4 text-white items-center justify-between">
				<div class="flex flex-1 items-start justify-between">
					<div class="flex flex-col">
						<span class="mb-2 font-bold" data-testid="driver-name">
							{{ auth.user?.name }} - {{ auth.user?.current_depot }}
						</span>

						<vehicles-dropdown
							v-if="auth.user!.current_vehicle == undefined || editingVehicle"
							v-model="vehicle"
							label-key="registration"
							@update:model-value="editingVehicle = false"
							@update:vehicle="
								(value: Vehicle) => (auth.user!.current_vehicle = value)
							" />

						<span v-else data-testid="current-vehicle">
							{{ auth.user?.current_vehicle.registration }}
							<app-icon
								v-if="!auth.vehicleLocked"
								:icon="['fas', 'fa-pencil']"
								class="text-blue-300 ms-1"
								@click="resetVehicle" />
						</span>
					</div>

					<div class="flex flex-col">
						<div class="flex gap-3">
							<button data-testid="prev-day" @click="app.prevDay">
								<app-icon :icon="['fas', 'angle-left']" />
							</button>
							<span data-testid="current-day">{{
								app.isToday() ? 'Today' : app.formattedDate
							}}</span>
							<button data-testid="next-day" @click="app.nextDay">
								<app-icon :icon="['fas', 'angle-right']" />
							</button>
						</div>

						<div v-if="!app.isToday()" class="text-center" data-testid="today-button">
							<button
								class="text-xs bg-white/20 px-2 py-[2px] rounded-sm"
								@click="app.today">
								<app-icon
									:icon="['fas', 'fa-clock-rotate-left']"
									class="w-[10px]" />
								Today
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Disclosure>
</template>

<script lang="ts" setup>
	import useAuthStore from '@/stores/auth'
	import useAppStore from '@/stores/app'
	import { Disclosure } from '@headlessui/vue'
	import VehiclesDropdown from '@/components/partials/dropdowns/VehiclesDropdown.vue'
	import { onMounted, ref } from 'vue'
	import { Vehicle } from '@/data/schema/vehicle'

	const auth = useAuthStore()
	const app = useAppStore()

	const vehicle = ref('')
	const editingVehicle = ref(false)

	function resetVehicle() {
		editingVehicle.value = true
		auth.user!.current_vehicle = undefined
	}

	onMounted(() => {
		if (auth.vehicle) {
			vehicle.value = auth.vehicle.id
		}
	})
</script>
